export const SideBarNavigate = 'SideBarNavigate';
